export const serverSettingsClientContext = {
  getAll: '/user-service/api/external/settings',
  getCurrent: '/user-service/api/external/settings/current',
};
